import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ProjectsService} from '../_services/projects.service';
import {SingleProjectModel} from '../_models/singleProject.model';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'app-stage-view',
    templateUrl: './stage-view.component.html',
    styleUrls: ['./stage-view.component.scss']
})
export class StageViewComponent implements OnInit, OnDestroy {
    dataLoaded = false;
    percentageLoaded = false;

    statusList = ['Active', 'Completed'];
    projectId: string;
    stageId: string;
    stageData: any;
    projectData: any;
    projectStaff = [];
    responsibleStaff = [];
    allUsersInfo = [];
    tasks = [];
    currentUserId: string;

    // array of current user roles
    userRoles = [];

    // Feedback Messages
    formResponse: boolean;
    formSent: boolean;
    successMsg = '';
    errorMsg = '';

    newTaskForm: FormGroup;
    subTasks = [];

    // progress bar by date
    progressBar = 0;
    barClass: string;
    spanColor: string;

    stagePercentage = 0;

    chartOptions: any = {};

    // User Permissions
    isAllowedToEdit = false;
    isAllowedToView = false;
    allowedToRemoveTasks = false;

    // Unsubscribe
    unsubscribe = [];

    constructor(private router: Router,
                private route: ActivatedRoute,
                private modalService: NgbModal,
                private projectsService: ProjectsService,
                private fb: FormBuilder) {
    }

    ngOnInit(): void {
        const routeSub = this.route.params.subscribe(params => {
            this.projectId = params.id;
            this.stageId = params.position;
            
        });
        this.unsubscribe.push(routeSub);

        const currentUser = this.projectsService.getCurrentUser().subscribe( (user: any) => {
            this.currentUserId = user.id;
            this.userRoles = user.roles;
            if (this.userRoles !== null) {
                if (this.userRoles.includes('ROLE_super_admin') || this.userRoles.includes('ROLE_admin')) {
                    this.allowedToRemoveTasks = true;
                }
            }

            this.checkForPermissions('Projects', this.userRoles);
        });
        this.unsubscribe.push(currentUser);

        this.projectsService.getProjectById(this.projectId).subscribe((project: SingleProjectModel) => {
            
            this.projectData = project;
            this.stageData = project.stage[Number(this.stageId) - 1];
            if (this.stageData && this.stageData.responsible) {
                const members = this.stageData.responsible;
                members.forEach(member => {
                    this.responsibleStaff.push({
                        responsibleId: member.responsibleId,
                        responsibleName: member.responsibleName
                    });
                });
            }
            this.projectStaff = project.staff;
            
            if (this.projectStaff.length > 0) {
                this.projectStaff.forEach( (staff: any) => {
                    this.projectsService.getUserById(staff).subscribe( (res: any) => {
                        this.allUsersInfo.push(res);
                    });
                });
            }
            

            this.projectsService.getStageCompletion(this.projectId, this.stageId).subscribe( (res: any) => {
                if (res.number !== null && res.number !== 'NaN') {
                    this.stagePercentage = Math.floor(res.number);
                }
                this.chartOptions = this.getChartOptions();
            });

            if (this.stageData.stageTasks) {
                this.stageData.stageTasks.forEach(stageTask => {
                    
                    const sub = this.projectsService.getTaskById(stageTask).subscribe( (res: any) => {
                        if (res.status !== 'removed') {
                            this.tasks.push(res);
                        }
                    });
                    this.unsubscribe.push(sub);
                    this.dataLoaded = true;
                });
            }

            this.getProgressColor();
            this.dataLoaded = true;
        });
    }

    checkForPermissions(moduleName: string, rolesArray: string[]) {
        if (rolesArray.includes('ROLE_super_admin') || rolesArray.includes('ROLE_admin')) {
            this.isAllowedToEdit = true;
            this.isAllowedToView = true;
            
        } else {
            if (rolesArray.includes(`ROLE_${moduleName}Full`)) {
                this.isAllowedToEdit = true;
                this.isAllowedToView = true;
                
            } else if (rolesArray.includes(`ROLE_${moduleName}View`)) {
                this.isAllowedToEdit = false;
                this.isAllowedToView = true;
                
            }
        }
    }

    loadTaskForm() {
        const today = new Date().toISOString().split('T')[0];
        let resMember;
        if (this.responsibleStaff && this.responsibleStaff[0] && this.responsibleStaff[0].responsibleId) {
            resMember = this.responsibleStaff[0].responsibleId;
        } else {
            resMember = '';
        }
        this.newTaskForm = this.fb.group({
            name: [null, Validators.required],
            description: [null],
            responsible: [resMember],
            dueDate: [today, Validators.required]
        });
        this.subTasks = [];
    }

    pushSubTask(value: string) {
        if (value !== null && value !== '') {
            this.subTasks.push({
                description: value,
                solved: false
            });
        }
    }

    removeSubTask(index) {
        this.subTasks.splice(index, 1);
    }

    submitTaskForm() {
        
        
        this.newTaskForm.markAllAsTouched();
        if (this.newTaskForm.valid) {
            const today = new Date().toISOString().split('T')[0];
            const taskToSend = {
                messageTitle: this.newTaskForm.value.name,
                messageDetail: this.newTaskForm.value.description,
                receiverUserId: this.newTaskForm.value.responsible,
                deadline: this.newTaskForm.value.dueDate + 'T09:18:19.108Z',
                subtasks: this.subTasks,
                senderUserId: this.currentUserId,
                id: 'string',
                labelTask: 'string',
                attachments: [{
                    name: 'string',
                    link: 'string'
                }],
                additionDate: today + 'T09:18:19.108Z',
                status: 'new',
                labelColour: 'string',
                projectId: this.projectId,
                projectStage: this.stageId,
                taskMessages: [{
                    message: 'string',
                    messageDate: '2022-03-25T09:18:19.108Z',
                    userId: 'string'
                }]
            };

            

            this.projectsService.createTaskERP(this.projectId, this.stageId, taskToSend).subscribe( (res: any) => {
                
                this.projectsService.getTaskById(res.reason).subscribe( nextRes => {
                    this.tasks.push(nextRes);
                    this.modalService.dismissAll();
                });
            }, error => {
                
                this.feedbackMsg('error', 'Something went wrong');
            });
        } else {
            this.feedbackMsg('error', 'Please fill out the required fields');
        }
    }

    getChartOptions() {
        this.percentageLoaded = true;
        const strokeColor = 'rgba(73, 80, 250, 1)';
        const bgColor = '#ffffff';
        const textColor = '#2E2A41';
        return {
            series: [this.stagePercentage],
            chart: {
                type: 'radialBar',
                height: 200,
            },
            plotOptions: {
                radialBar: {
                    hollow: {
                        margin: 0,
                        size: '65%',
                    },
                    dataLabels: {
                        showOn: 'always',
                        name: {
                            show: false,
                            fontWeight: '700',
                        },
                        value: {
                            color: textColor,
                            fontSize: '30px',
                            fontWeight: '700',
                            offsetY: 12,
                            show: true,
                        },
                    },
                    track: {
                        background: bgColor,
                        strokeWidth: '100%',
                        opacity: 1,
                        startAngle: -180,
                        endAngle: 180
                    },
                },
            },
            colors: [strokeColor],
            labels: ['Progress'],
            legend: {},
            dataLabels: {},
            fill: {},
            xaxis: {},
            yaxis: {},
            states: {
                normal: {
                    filter: {
                        type: 'none'
                    }
                },
                hover: {
                    filter: {
                        type: 'none'
                    }
                },
                active: {
                    allowMultipleDataPointsSelection: false,
                    filter: {
                        type: 'none'
                    }
                }
            },
            tooltip: {},
            markers: {},
        };
    }

    // setam culoarea progress bar-ului cu due date si span-ul de sub el
    getProgressColor() {
        const start = new Date(this.stageData.startDate);
        const end = new Date(this.stageData.deadLine);
        const today = new Date();
        
        /*        const start = new Date('2022-01-15');
                const today = new Date('2022-02-16');
                const end = new Date('2022-02-28');*/

        const totalDays = Math.floor((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
        const daysElapsed = Math.floor((today.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));

        if (today > end) {
            this.progressBar = 100;
            // 
        } else if (today < start) {
            this.progressBar = 0;
            // 
        } else if (today >= start && today <= end){
            this.progressBar = Math.floor(100 * daysElapsed / totalDays);
            // 
        } else {
            this.progressBar = 0;
        }


        if (this.progressBar <= 25) {
            this.barClass = 'bg-success';
            this.spanColor = '#1bc5bd';
        } else if (this.progressBar > 25 && this.progressBar <= 50) {
            this.barClass = 'bg-info';
            this.spanColor = '#8950fc';
        } else if (this.progressBar > 50 && this.progressBar <= 75) {
            this.barClass = 'bg-warning';
            this.spanColor = '#ffa800';
        } else if (this.progressBar > 75 && this.progressBar <= 100) {
            this.barClass = 'bg-danger';
            this.spanColor = '#f64e60';
        }

        
        

    }

    openModal(modal) {
        this.loadTaskForm();
        this.modalService.open(modal, {centered: true});
    }

    addNewMember(user) {
        let duplicateStaff = false;
        this.responsibleStaff.forEach( (staffMember: any) => {
            if (staffMember.responsibleId === user.id) {
                duplicateStaff = true;
            }
        });
        if (duplicateStaff) {
            
            this.feedbackMsg('error', 'This member is already selected');
        } else {
            
            const name = user.lastName + ' ' + user.firstName;
            const newMember = {
                responsibleId: user.id,
                responsibleName: name
            };
            this.stageData.responsible.push(newMember);
            

            this.projectsService.updateProjectStage(this.projectId, Number(this.stageId), this.stageData).subscribe( res => {
                
                this.responsibleStaff.push(newMember);
                this.modalService.dismissAll();
            });
            
        }
    }

    removeMember(memberId, index) {
        
        this.stageData.responsible.splice(index, 1);

        this.projectsService.updateProjectStage(this.projectId, Number(this.stageId), this.stageData).subscribe( res => {
            
            this.responsibleStaff.splice(index, 1);
        });
    }

    removeTask(taskId, index) {
        

        this.projectsService.changeTaskERPStatus(taskId, 'removed').subscribe( statusRes => {
            this.tasks.splice(index, 1);
        });
    }

    removeProjectStage() {
        
        this.projectData.stage.splice(Number(this.stageId) - 1, 1);
        const sub = this.projectsService.editProject(this.projectId, this.projectData).subscribe( res => {
            this.router.navigate([`/projects/${this.projectId}`]);
        });
        this.unsubscribe.push(sub);

    }

/*    removeTask(taskId, index) {
        this.stageData.stageTasks.splice(index, 1);

        this.projectsService.deleteTaskERP(taskId).subscribe( res => {
            
            this.tasks.splice(index, 1);
        });
    }*/

    onClickTask(task) {
        
    }

    // Scroll Top
    scrollToTop() {
        window.scrollTo({top: 0, behavior: 'smooth'});
    }


    isControlInvalid(controlName: string): boolean {
        const control = this.newTaskForm.controls[controlName];
        return control.invalid && (control.dirty || control.touched);
    }


    controlHasError(validation: string, controlName: string) {
        const control = this.newTaskForm.controls[controlName];
        return control.hasError(validation) && (control.dirty || control.touched);
    }

    // FeedBack Msg
    feedbackMsg(type, message) {
        if (type === 'success') {
            this.formSent = true;
            this.formResponse = true;
            this.successMsg = message;

            setTimeout(() => {
                this.formSent = false;
            }, 4000);

        } else if (type === 'error') {
            this.formSent = true;
            this.formResponse = false;
            this.errorMsg = message;

            setTimeout(() => {
                this.formSent = false;
            }, 4000);
        }
    }

    ngOnDestroy() {
        this.unsubscribe.forEach(sb => sb.unsubscribe());
    }


}
